import { Component } from 'react';

export default class CustomSelect extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  handleSelection(key) {
    this.setState({ open: false });
    this.props.onChange(key);
  }

  handleFocus() {
    this.setState({ open: true });
  }

  handleBlur() {
    this.setState({ open: false });
  }

  render() {
    const options = Object.keys(this.props.options).map((key) => {
      return (
        <div
          className="custom-select-option custom-select-option"
          key={key}
          onMouseDown={this.handleSelection.bind(this, key)}
        >
          {this.props.options[key]}
        </div>
      );
    });
    const optionsMarkup = (
      <div className="custom-select-options">{options}</div>
    );
    return (
      <div className="custom-select inline-block">
        <input
          className="minimal-text-input custom-select-input"
          readOnly
          value={this.props.value}
          onFocus={this.handleFocus.bind(this)}
          onBlur={this.handleBlur.bind(this)}
        />
        {this.state.open && optionsMarkup}
        <span className="custom-select-symbol"></span>
      </div>
    );
  }
}
